import { styled } from "@material-ui/core";

// Super weirdly, using Typography here changed the global page styles...
const IssueTitle = styled("h3")({
  marginTop: 0,
  marginBottom: 8,
});

export default IssueTitle;
